import React, { createContext, useState } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [refresh_global, setRefreshGlobal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshTriggers, setRefreshTriggers] = useState({});
  const triggerRefresh = (key) => {
    setRefreshTriggers((prev) => ({
      ...prev,
      [key]: (prev[key] || 0) + 1,
    }));
  };
  return (
    <GlobalContext.Provider
      value={{
        refreshTriggers,
        triggerRefresh,
        refresh_global,
        setRefreshGlobal,
        loading,
        setLoading,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
